
import React, { useState } from 'react';

interface HeaderProps {
  isScrolled: boolean;
}

const Header: React.FC<HeaderProps> = ({ isScrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Services', id: 'services' },
    { name: 'Solutions', id: 'work' },
    { name: 'Pricing', id: 'pricing' },
    { name: 'Contact', id: 'contact' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  // Text color logic based on scroll state
  const textColorClass = isScrolled ? 'text-slate-600' : 'text-slate-300';
  const logoColorClass = isScrolled ? 'text-slate-900' : 'text-white';
  const mobileMenuBtnClass = isScrolled ? 'text-slate-900' : 'text-white';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`}>
      <div className="container mx-auto px-6 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2 group outline-none">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-700 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/20 group-hover:rotate-12 transition-transform">
            <i className="fas fa-layer-group text-white text-xl"></i>
          </div>
          <span className={`text-2xl font-extrabold tracking-tighter transition-colors duration-300 ${logoColorClass}`}>LookApp.Au</span>
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button 
              key={link.name} 
              onClick={() => scrollToSection(link.id)} 
              className={`${textColorClass} hover:text-blue-400 transition-colors text-sm font-semibold uppercase tracking-widest outline-none`}
            >
              {link.name}
            </button>
          ))}
          <button 
            onClick={() => scrollToSection('contact')} 
            className={`px-6 py-2.5 font-bold rounded-full transition-all text-sm outline-none shadow-lg ${isScrolled ? 'bg-slate-900 text-white hover:bg-slate-800 shadow-slate-900/10' : 'bg-white text-slate-900 hover:bg-slate-100 shadow-white/5'}`}
          >
            GET STARTED
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button className={`md:hidden text-2xl transition-colors duration-300 ${mobileMenuBtnClass}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-2xl border-b border-slate-100 p-6 flex flex-col gap-6 animate-in slide-in-from-top duration-300">
          {navLinks.map((link) => (
            <button 
              key={link.name} 
              onClick={() => scrollToSection(link.id)} 
              className="text-left text-xl font-bold text-slate-800 outline-none"
            >
              {link.name}
            </button>
          ))}
          <button 
            onClick={() => scrollToSection('contact')} 
            className="w-full py-4 bg-slate-900 text-white text-center font-bold rounded-xl outline-none"
          >
            GET STARTED
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
